






























































































import Vue from 'vue';
import axios from 'axios';
import { mapState } from 'vuex';
import HubIcon from '@/components/HubComponents/HubIcon.vue';
import jwtDecode from 'jwt-decode';

export default Vue.extend({
  name: 'NavbarMenu',

  components: {
    HubIcon,
  },

  data() {
    return {
      menuItems: [] as {
        icon: string;
        label: string;
        ref: string;
        route: string;
        hasSubmenu?: boolean;
      }[],
      submenuItems: [] as { icon: string; label: string; ref: string; route: string }[],
      otherMenus: [] as { icon: string; label: string; ref: string; route: string }[],
      showSubmenu: false,
      showTooltip: false,
      customerPlansId: 0,
      id_customer: 0,

    };
  },

  computed: mapState(['user']),

  mounted() {
    this.initializeMenuItems();
    this.checkSubmenuDisplay();
  },

  methods: {
    initializeMenuItems() {
      const userInfo = localStorage.getItem('user');
      if (userInfo) {
        const customerObjectId = JSON.parse(userInfo);
        this.customerPlansId = customerObjectId.user.plan_id;
        const userToken = customerObjectId.token;
        const decodedToken = jwtDecode(userToken) as any;
        this.id_customer = decodedToken.sub.id_customers;
      }
      const { pathname } = window.location;
      let page: Store.User.Page | undefined;

      if (pathname.includes('login/hub/events/')) page = 'events';
      if (pathname.includes('login/hub/uploads/')) page = 'uploads';
      else if (pathname.includes('login/hub/hotsites/')) page = 'hotsites';
      else page = (this.user as Store.User.State).page;

      const menuItems = page !== 'hotsites'
        ? [
          {
            label: 'events', icon: 'videos', route: 'Events', ref: 'events-btn',
          },
          {
            label: 'uploads', icon: 'upload', route: 'Uploads', ref: 'uploads-btn',
          },
          {
            label: 'galleries', icon: 'mdi-folder', route: 'Galleries', ref: 'galleries-btn', hasSubmenu: true,
          },
        ]
        : [
          {
            label: 'Channels', icon: 'menu', route: 'Channels', ref: 'hotsites-btn',
          },
        ];

      const otherMenus = page !== 'hotsites'
        ? [{
          label: 'Logs', icon: 'mdi-account-details', route: 'Logs', ref: 'logs-btn',
        }]
        : [];

      this.menuItems = menuItems;
      this.otherMenus = otherMenus;
    },

    checkSubmenuDisplay() {
      const { pathname } = window.location;
      this.showSubmenu = this.menuItems.some(
        (item) => (item.route === 'Galleries' || item.route === 'Transcription')
          && (pathname.includes('galleries') || pathname.includes('transcription')),
      );
    },

    handleMenuItemClick(route: string) {
      if (route === 'Galleries') {
        this.showSubmenu = true;
      } else {
        this.showSubmenu = false;
      }
    },

    handleSubmenuItemClick(route: string) {
      this.$router.push({ name: route });
    },
    async handleHubClick(event: any) {
      event.preventDefault();

      const userInfo = localStorage.getItem('user');
      // eslint-disable-next-line @typescript-eslint/camelcase
      let customer_id;
      // eslint-disable-next-line @typescript-eslint/camelcase
      let plan_id;
      if (userInfo) {
        const customerObjectId = JSON.parse(userInfo);
        // eslint-disable-next-line @typescript-eslint/camelcase
        plan_id = customerObjectId.user.plan_id;
        const userToken = customerObjectId.token;
        const decodedToken = jwtDecode(userToken) as any;
        // eslint-disable-next-line @typescript-eslint/camelcase
        customer_id = decodedToken.sub.id_customers;
      }

      const apiUrl = process.env.VUE_APP_API_URL;
      const hubApi = process.env.VUE_APP_HUB_API_URL;
      try {
        const response = await axios.post(`${apiUrl}/auth/createtokenauthenticatelogin`, {
          plan_id,
          customer_id,
        });

        if (response.data.status === 200) {
          const { token } = await response.data;
          window.location.href = `${hubApi}/#/loginfromhub2/${token}`;
        } else {
          console.error(response.data.message);
        }
      } catch (error) {
        console.error('Erro ao criar token:', error);
      }
    },
    isCurrentRoute(route: string) {
      return this.$route.name === route;
    },
  },
});
